import MultiColorTitle from './MultiColorTitle';

export default MultiColorTitle; 